import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={124}
    height={props.width|| 124}
    viewBox="0 0 124 124"
    fill="none"
    style={{cursor:'pointer'}}
    {...props}
  >
    <path
      fill="#fff"
      d="m35.467 27.115 61.43 61.43-8.777 8.775-61.429-61.429z"
    />
    <path fill="#fff" d="m96.896 35.89-61.43 61.43-8.775-8.776 61.429-61.43z" />
  </svg>
)
export default SvgComponent
